import React, { useState } from "react";
import { auth } from "../../firebase";

const URL = "https://us-central1-bar-buzz-a6645.cloudfunctions.net/sendTestReport";

// Emails YOU (the admin) a preview of the Monday weekly report
// for up to 3 claimed bars, so you can see what owners get.
export default function TestReportButton() {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const send = async () => {
    setBusy(true);
    setMsg("");
    try {
      const token = await auth.currentUser?.getIdToken();
      const res = await fetch(URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: "{}",
      });
      const data = await res.json();
      if (data.ok) setMsg(`✓ Sent a preview to ${data.sentTo} (${data.previews} bar${data.previews === 1 ? "" : "s"}). Check your inbox and spam folder.`);
      else setMsg(data.error || "Something went wrong.");
    } catch (e) {
      setMsg("Couldn't reach the server. Try again.");
    }
    setBusy(false);
  };

  return (
    <div style={{ background: "rgba(255,255,255,0.05)", padding: "18px", borderRadius: "12px", marginBottom: "24px" }}>
      <h3 style={{ margin: "0 0 6px" }}>Weekly owner report</h3>
      <p style={{ margin: "0 0 12px", color: "#B8B0C8" }}>
        Goes out automatically every Monday at 8am to every bar owner. Click below to email yourself a preview.
      </p>
      <button
        onClick={send}
        disabled={busy}
        style={{ padding: "10px 16px", borderRadius: "10px", border: "none", background: "#FF3D81", color: "#0B0B12", fontWeight: 700, cursor: busy ? "default" : "pointer" }}
      >
        {busy ? "Sending…" : "Send me a test report"}
      </button>
      {msg && <p style={{ margin: "10px 0 0" }}>{msg}</p>}
    </div>
  );
}
